var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQuery } from 'react-query';
import { api } from '../environment.vars';
import { MethodType } from './createAPICall';
import { maestroApiCall } from './maestroDataSource';
import { ShareValues } from './ShareValues';
export function sendNotification(body, token) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, URL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = ShareValues.getAuthResultTokenAccess();
                    URL = "".concat(api, "/notifications/notifications");
                    return [4 /*yield*/, fetch(URL, {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token || accessToken),
                            },
                            method: 'POST',
                            body: JSON.stringify(body),
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
// @Deprecated
export function sendTemplatedNotification(body, token) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, URL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = ShareValues.getAuthResultTokenAccess();
                    URL = "".concat(api, "/notifications/from-template");
                    return [4 /*yield*/, fetch(URL, {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(token || accessToken),
                            },
                            method: 'POST',
                            body: JSON.stringify(body),
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var updateAllNotifications = function (data) {
    var apiType = {
        method: MethodType.PUT,
        endpoint: '/notifications/notifications',
        baseURL: api,
    };
    return maestroApiCall(apiType, data).then(function (response) { return response; });
};
var updateNotification = function (data) {
    var apiType = {
        method: MethodType.PUT,
        endpoint: "/notifications/notifications/".concat(data.notification_id),
        baseURL: api,
    };
    return maestroApiCall(apiType, data).then(function (response) { return response; });
};
var getNotifications = function (application) {
    if (!application) {
        return null;
    }
    return maestroApiCall({
        method: MethodType.GET,
        endpoint: "notifications/notifications?app_key=".concat(application, "&daysFromCreation=30"),
        baseURL: api,
    }).then(function (response) { return response; });
};
export function useGetNotifications(application) {
    return useQuery(['notifications', application], function () { return getNotifications(application); }, {
        staleTime: 30000,
        enabled: false,
        keepPreviousData: true,
    });
}
export var useUpdateNotification = function (onSuccess) {
    var _a = useMutation(updateNotification, __assign({}, (onSuccess && { onSuccess: function () { return onSuccess(); } }))), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { mutateAsync: mutateAsync, isLoading: isLoading };
};
export var useUpdateAllNotifications = function (onSuccess) {
    var _a = useMutation(updateAllNotifications, __assign({}, (onSuccess && { onSuccess: function () { return onSuccess(); } }))), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { mutateAsync: mutateAsync, isLoading: isLoading };
};
//# sourceMappingURL=notificationAPI.js.map